import { render } from "./HeaderCentral.vue?vue&type=template&id=26d20156"
import script from "./HeaderCentral.vue?vue&type=script&lang=js"
export * from "./HeaderCentral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__